import { render, staticRenderFns } from "./TrainingCourseEnrollmentTable.vue?vue&type=template&id=3da24329&"
import script from "./TrainingCourseEnrollmentTable.vue?vue&type=script&lang=js&"
export * from "./TrainingCourseEnrollmentTable.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCourseEnrollmentTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VDataTable,VProgressLinear,VRow})
